import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';
import { COLORS } from '@livecommerce/design-system';

const StyledCell = styled.div`
  min-height: 39px;
  height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
  width: ${(props) => props.width ? `${props.width}px` : 'calc(100% - 4px)'};
  flex-shrink: 0;

  border-radius: ${(props) => props.borderRadius}px;
  animation: pulse ease-in-out 2s infinite;
  background-color: ${COLORS.light_400};

  @keyframes pulse {
    0% {
      opacity: ${(props) => props.opacityOption.initial};
    }

    50% {
      opacity:${(props) => props.opacityOption.end};
    }

    100% {
      opacity: ${(props) => props.opacityOption.initial};
    }
  }
`;

const opacityOptions = {
  light: {
    initial: 0.6,
    end: 0.4,
  },
  dark: {
    initial: 0.4,
    end: 0.2,
  },
};

const SkeletonCell = ({ width, height, borderRadius = 6, opacityVariant = 'light', ...props }) => {
  return (
    <StyledCell
      width={width}
      height={height}
      borderRadius={borderRadius}
      opacityOption={opacityOptions[opacityVariant]}
      {...props}
    />
  );
};

SkeletonCell.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  borderRadius: PropTypes.number,
};

export default SkeletonCell;
